import { useLocale } from "@/locale/LocaleContext";
import styles from "./ui.module.css";

export function DemoChip({ label }: { label?: "DEMO" | "LIVE" }) {
  const { m } = useLocale();
  const text = label === "LIVE" ? m.demo.liveChip : m.demo.chip;
  return <span className={styles.chip}>{text}</span>;
}
